exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n[data-v-1a2d0fa9] .el-tabs__item {\n  background-color: #abaca8;\n  color: #fff !important;\n}\n[data-v-1a2d0fa9] .el-tabs__item.is-active {\n  background-color: #78a5e7;\n  color: #fff !important;\n}\n[data-v-1a2d0fa9] .el-tabs__header {\n  display: flex;\n  justify-content: flex-end;\n  /* Đẩy tab sang phải */\n}\n[data-v-1a2d0fa9] .el-tabs--border-card > .el-tabs__header .el-tabs__item {\n  border: none;\n}\n[data-v-1a2d0fa9] .el-tabs--card > .el-tabs__header {\n  margin-bottom: 0;\n  border-bottom: none;\n}\n[data-v-1a2d0fa9] .el-tabs__nav-wrap {\n  border-bottom: 1px solid #DCDFE6;\n}\n", ""]);

// exports
